export default __webpack_public_path__ + "static/media/demo1.33e9fef0.PNG";